import { useEvents } from "api/events";
import { SelectInput } from "components/FormControls/Select/Select";
import { useFormikContext } from "formik";
import { useMessage } from "hooks/intl";
import { useManageInfiniteScroll } from "hooks/useManageInfiniteScroll";
import _ from "lodash";
import { useState } from "react";
import { EventSchemaFormValues } from "../../CustomEvent/SchemaForm/CustomEventSchema";
import { CustomEventFetcher } from "./CustomEventFetcher";

export function CustomEventDropdown({ fieldName }: { fieldName: string }) {
  const { message } = useMessage();
  const { values } = useFormikContext<any>();
  const { useInfiniteCustomEventsSchemaList } = useEvents();
  const [customEventSearch, setCustomEventSearch] = useState("");

  const {
    data: infiniteCustomEventsSchemaList,
    size: customEventsSchemaSize,
    setSize: setCustomEventsSchemaSize,
    isValidating,
  } = useInfiniteCustomEventsSchemaList({
    filters: customEventSearch
      ? [
          {
            condition: "like",
            query: "name",
            value: customEventSearch,
          },
          {
            query: "active",
            condition: "eq",
            value: true,
          },
        ]
      : [
          {
            query: "active",
            condition: "eq",
            value: true,
          },
        ],
    order: "asc",
    sortKey: "name",
  });

  const {
    infiniteData: customEventsSchemaList,
    anyElementsToFetch: anyCustoEventsSchemaToFetch,
  } = useManageInfiniteScroll(infiniteCustomEventsSchemaList || []);

  const value = _.get(values, fieldName);
  const selectAllEvents = _.get(
    values,
    "activeMember.customEventsInXDays.allEvents",
  );
  const formData = value;

  const [listOfFetchedCustomEvents, setListOfFetchedCustomEvents] = useState<
    EventSchemaFormValues[]
  >([]);

  const eventsList = customEventsSchemaList.map((level) => ({
    label: level.name,
    id: level.eventType,
  }));

  return (
    <>
      {formData?.map((item: string, index: number) => (
        <CustomEventFetcher
          id={item}
          key={index}
          setListOfFetchedCustomEvents={(data) => {
            setListOfFetchedCustomEvents((previousArrayState) => [
              ...previousArrayState,
              data,
            ]);
          }}
        />
      ))}
      <SelectInput
        disabled={selectAllEvents}
        name={fieldName}
        multiple
        displaySearch
        items={eventsList}
        placeholder={message({ id: "event" })}
        data-test-id="active-member-settings-event-select"
        asyncSearch={(value) => {
          setCustomEventSearch(value);
        }}
        initialValue={
          listOfFetchedCustomEvents
            ? listOfFetchedCustomEvents.map((event) => ({
                label: event.name,
                id: event.eventType as string,
              }))
            : []
        }
        anyElementsToFetch={anyCustoEventsSchemaToFetch}
        loadMoreElements={() =>
          !isValidating && setCustomEventsSchemaSize(customEventsSchemaSize + 1)
        }
      />
    </>
  );
}
